import algoliasearch, { SearchClient } from "algoliasearch/lite";

const ALGOLIA_APP_ID = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID;
const ALGOLIA_INDEX_NAME = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME;
const ALGOLIA_SEARCH_API_KEY = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY;

type SearchClientSingleton = {
  searchClient: SearchClient;
  indexName: string;
};

let algoliaSearchSingleton: SearchClientSingleton | undefined;

export const getAlgoliaSearch = () => {
  if (!algoliaSearchSingleton && ALGOLIA_APP_ID && ALGOLIA_INDEX_NAME && ALGOLIA_SEARCH_API_KEY) {
    algoliaSearchSingleton = {
      searchClient: algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY),
      indexName: ALGOLIA_INDEX_NAME,
    };
  }

  return algoliaSearchSingleton;
};
